import React, { useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

import Homepage from './pages/Homepage';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Onboarding from './pages/Onboarding';
import Dashboard from './pages/Dashboard';
import Admin from './pages/Admin';
import Wallet from './pages/Wallet';

import PrivateRoute from './components/PrivateRoute';
import PublicRoute from './components/PublicRoute';
import RequireOnboarded from './components/RequireOnboarded';
import RequireAdmin from './components/RequireAdmin';

import { pageview, trackConnectGroupClick } from './analytics';

/**
 * AnalyticsHub:
 * - Dispara page_view no load e a cada mudança de rota.
 * - Heurística de "home -> login" como *fallback* para marcar CTA,
 *   MAS ignora se `window.__ctaManualFired` estiver true (foi marcado no clique).
 */
function AnalyticsHub() {
  const location = useLocation();
  const prevPathRef = useRef(null);

  useEffect(() => {
    const path = location.pathname + location.search + location.hash;

    if (prevPathRef.current !== path) {
      // Fallback do CTA apenas se não marcamos manualmente no clique
      if (prevPathRef.current === '/' && location.pathname === '/login') {
        if (!window.__ctaManualFired) {
          trackConnectGroupClick('homepage_to_login');
        }
        // reseta a flag para próximas navegações
        window.__ctaManualFired = false;
      }

      pageview(path);
      prevPathRef.current = path;
    }
  }, [location]);

  return null;
}

function App() {
  return (
    <Router>
      <AnalyticsHub />

      <Routes>
        {/* landing */}
        <Route path="/" element={<Homepage />} />

        {/* públicas */}
        <Route
          path="/login"
          element={<PublicRoute><Login /></PublicRoute>}
        />
        <Route
          path="/signup"
          element={<PublicRoute><Signup /></PublicRoute>}
        />

        {/* logado, sem exigir onboarding */}
        <Route
          path="/onboarding"
          element={<PrivateRoute><Onboarding /></PrivateRoute>}
        />

        {/* dashboard: login + onboarded */}
        <Route
          path="/dashboard"
          element={<RequireOnboarded><Dashboard /></RequireOnboarded>}
        />

        {/* admin: login + admin (NÃO usa RequireOnboarded) */}
        <Route
          path="/admin"
          element={
            <PrivateRoute>
              <RequireAdmin>
                <Admin />
              </RequireAdmin>
            </PrivateRoute>
          }
        />

        <Route
          path="/wallet"
          element={<RequireOnboarded><Wallet /></RequireOnboarded>}
        />

        {/* opcionais para path-style */}
        <Route path="/wallet/:id" element={<RequireOnboarded><Wallet /></RequireOnboarded>} />
        <Route path="/wallet/view/:id" element={<RequireOnboarded><Wallet /></RequireOnboarded>} />
      </Routes>
    </Router>
  );
}

export default App;